// Bundle theme module
import NSTheme from './NSTheme';
import Helper from './Classes/Helper';
import Accordion from './Classes/Accordion';
import FocusHandler from './Classes/FocusHandler';
import Jump from './Classes/Jump'
import LazyLoad from './Classes/Lazyload';
import Sticky from '../../node_modules/sticky-js';
import ResponsiveTablesLight from "./Classes/ResponsiveTablesLight";
import ScrollToTop from "./Classes/ScrollToTop";
import Toggler from './Classes/Toggler';
import Navigation from './Classes/Navigation';
import SetTargetBlank from './Classes/SetTargetBlank';
import FootnoteSpan from './Classes/FootnoteSpan';
import CountUpNumbers from './Classes/countUpNumbers';
import SubnavigationMarkup from './Classes/SubnavigationMarkup';
import SubnavigationFunctionality from './Classes/SubnavigationFunctionality';
import Video from "./Classes/Video";
import swiper from '../../node_modules/swiper/swiper-bundle';
import TableFootnotes from './Classes/TableFootnotes';
import CurrencyDecimalReplacer from './Classes/CurrencyDecimalreplacer';
import InteractiveSvg from './Classes/InteractiveSvg';
import Lottie from "./Classes/Lottie";

module.exports = NSTheme;

var sliderInstance = null;
var swiperInstance = null;
var interactiveSvg = null;

// Slider events?
document.addEventListener("DOMContentLoaded", function () {

  // remove lazyload from swiper images
  const swiperImages = document.querySelectorAll('.ns-slider__inner--image .ns-slider__item-img');
  swiperImages.forEach(swiperImage => {
    if (swiperImage.classList.contains('lazy')) {
      swiperImage.classList.remove('lazy');
      swiperImage.src = swiperImage.getAttribute('data-src');
    }
  });

  //Helper.loadImagesInContainer('.ns-slider');

  const sliders = document.querySelectorAll('.ns-slider');
  sliders.forEach(slider => {
    // prev-next is outside of .swiper
    const prev = slider.querySelector('.ns-slider__prev')
    const next = slider.querySelector('.ns-slider__next')

    const swip = new swiper(slider.querySelector('.swiper'), {
      slidesPerView: 1,
      centeredSlides: true,
      wrapperClass: 'swiper-wrapper',
      initialSlide: 0,
      loop: true,
      loopedSlides: 20,
      navigation: {
        nextEl: ".ns-slider__next",
        prevEl: ".ns-slider__prev",
      },

      breakpoints: {
        512: {
          initialSlide: 0,
          slidesPerView: 1,
          centeredSlides: false,
        },
        1024: {
          initialSlide: 0,
          slidesPerView: 1,
          centeredSlides: true,
        }
      },
    });

    // manual click events
    prev.addEventListener('click', (e) => {
      swip.slidePrev();
    });
    next.addEventListener('click', (e) => {
      swip.slideNext();
    });
  });

  const carousels = document.querySelectorAll('.lc-carousel');
  carousels.forEach(carousel => {
    // prev-next is outside of .swiper
    const prev = carousel.querySelector('.lc-carousel__prev')
    const next = carousel.querySelector('.lc-carousel__next')

    const swip = new swiper(carousel.querySelector('.swiper'), {
      effect: "coverflow",
      grabCursor: true,
      centeredSlides: true,
      loop: true,
      slidesPerView: "auto",
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 200,
        modifier: 2.5,
        slideShadows: false,
      },
      // autoplay: {
      //   delay: 3000,
      //   disableOnInteraction: false,
      // }
    });

    // manual click events
    prev.addEventListener('click', (e) => {
      swip.slidePrev();
    });
    next.addEventListener('click', (e) => {
      swip.slideNext();
    });
  });

  new TableFootnotes();

  toTopInstance = new ScrollToTop({
    buttonSelector: '.js-backtotop-toggle'
  });
});

// everything else???
(function () {
  document.addEventListener('DOMContentLoaded', () => {

    new Navigation({
      menuTogglerSelector: '.js-nav-dropdown-toggler',
      burgerSelector: '.burger',
      searchToggle: '.search-toggle',
      searchToggleContainer: '.site-search'
    });

    new Toggler({
      togglerButtonSelector: '.ns-portrait__readmore-toggle',
      togglerContainerSelector: '.ns-portait__readmore-content'
    });

    new FocusHandler();

    new Accordion({
      accordions: '.js-toggle-accordion'
    });

    new Jump({
      graphicSelector: '.ns-graphic'
    });

    new LazyLoad();

    new Lottie();

    if (Helper.isDesktop()) {
      new Sticky('.header__bottom');
    }

    new ResponsiveTablesLight({
      tableComponentSelector: '.ns-table-wrap',
      tableContainerSelector: '.srl-table-container',
      tableSelector: '.ns-table-wrap table'
    });

    new SetTargetBlank({
      targetBlanks: '.js-anchor-target'
    });

    // new FootnoteSpan({
    //   footnoteSelector: 'p.ns-style-footnote'
    // });

    new Video();

    new CountUpNumbers({
      numbersSelector: '.ns-keyfigures__item:not(.no-countup) .ns-keyfigures__number',
      classIn: 'is-in-viewport',
      classOut: 'is-not-in-viewport',
      langArray: ['de-DE', 'en-US'],
      decimalArray: [',', '.'],
      thousandSepArray: ['', '']
    });

    new SubnavigationMarkup({
      header: '.ns-header',
      linkClass: '.menu__item--level-1'
    });

    new SubnavigationFunctionality({});

    new CurrencyDecimalReplacer({
      currencySelectors: 'span.cur, span.curb'
    });

    interactiveSvg = new InteractiveSvg({
      idName: 'trigger_',
      className: 'lc-interactive-svg__popup--'
    });

  })
})();
